import React, { useCallback, useEffect, useRef, useState } from "react";
import "../invoice.css";
import LoanStatementInvoicePage from "./LoanStatementInvoicePage";
import { Link } from "react-router-dom";

const DownloadBtnLoanStatementPdf = ({ auth, loading, startDate, endDate }) => {
  const [timeLeft, setTimeLeft] = useState(5);
  const [isActive, setIsActive] = useState(false);
  const [isClickToGeneratePDF, setIsClickToGeneratePDF] = useState(false);

  const triggerPDFGeneration = useCallback(() => {
    console.log("PDF Generation triggered!");
    setIsClickToGeneratePDF(true);
  }, []);

  useEffect(() => {
    let timer = null;

    if (isActive && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      triggerPDFGeneration();
      timer = setTimeout(() => {
        setIsActive(false);
        loading(false);
        clearInterval(timer);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [isActive, timeLeft, triggerPDFGeneration]);

  const startCountdown = () => {
    loading(true);
    setTimeLeft(5);
    setIsActive(true);
    setIsClickToGeneratePDF(false);
  };

  return (
    <>
      {isActive && (
        <LoanStatementInvoicePage
          startDate={startDate}
          endDate={endDate}
          auth={auth}
          isClickToGeneratePDF={isClickToGeneratePDF}
        />
      )}
      <Link
        className="btn btn-alt-secondary"
        style={{ textTransform: "capitalize" }}
        onClick={() => {
          startCountdown();
        }}
      >
        <i className="fa fa-download" aria-hidden="true"></i> Download PDF
      </Link>
    </>
  );
};
export default DownloadBtnLoanStatementPdf;
